export default __webpack_public_path__ + "static/media/add-schedule-enabled.e9f31c3b.svg";